class GrowingBox {
    constructor() {
        this.boxes = document.querySelectorAll('[data-growing-box]');
    }

    init() {
        if (this.boxes.length > 0 ) {
            this.bindEvents();
        }
    }

    bindEvents() {
        const boxes = this.boxes;

        boxes.forEach(box => {
            const button = box.querySelector('[data-growing-box-trigger]');
            if (button) {
                button.addEventListener('click', function (event) {
                    box.classList.toggle('is-open');
                });
            }
        });
    }
}

export default new GrowingBox();
